import { Info } from "@phosphor-icons/react";

import { tagVariants } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

export default function NonRenewingTag() {
  return (
    <Tooltip>
      <TooltipTrigger
        className={tagVariants({ variant: "danger", icon: "right" })}
      >
        Scheduled cancellation <Info weight="fill" />
      </TooltipTrigger>

      <TooltipContent>
        This subscription is scheduled for cancellation
      </TooltipContent>
    </Tooltip>
  );
}
